export const EventsData = [
  {
    "EventName": "36th National Games (Athletic, Squash, Triathlon, Softball)",
    "Para1": "The 2022 National Games of India, also known as the 36th National Games of India and informally as Gujarat 2022, was the 36th edition of the National Games of India and was held in Ahmedabad, Gandhinagar, Surat, Vadodara, Rajkot and Bhavnagar in the state of Gujarat between 29 September and 12 October 2022",
    "Para2": "IIT Gandhinagar hosted Athletics, Squash, Softball, and Triathalon events of the National Games 2022.",
    "Images": [
      require("../assets/events/National Games-1.jpg"),
      require("../assets/events/National Games-2.jpg"),
      require("../assets/events/National Games-3.jpg"),
      require("../assets/events/National Games-4.jpg"),
      require("../assets/events/National Games-5.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/National Games-1.jpg"),
    "ExternalLink":"https://nationalgamesgujarat.in/"
  },
  {
    "EventName": "Junior Rugby Nationals",
    "Para1": "25 States fight it out at the 7th Sub Junior National Rugby Sevens Championships 2022",
    "Para2": "The two-day Sub Junior National Rugby Sevens Championships 2022 commenced at IIT Gandhinagar, Gujarat started on Wednesday with the total participation of 24 teams in the U14 Girls category and 25 teams in the U14 Boys category.",
    "Images": [
      require("../assets/events/Junior Rugby Nationals-1.jpg"),
      require("../assets/events/Junior Rugby Nationals-2.jpg"),
      require("../assets/events/Junior Rugby Nationals-3.jpg"),
      require("../assets/events/Junior Rugby Nationals-4.jpg"),
      require("../assets/events/Junior Rugby Nationals-4.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Junior Rugby Nationals-1.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "ONGC Annual National Athletic Meet",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/ONGC Annual National Athletic Meet-1.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/ONGC Annual National Athletic Meet-1.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "Apollo Hospitals Annual Sports Meet",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/Apollo Hospitals Annual Sports Meet-1.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Apollo Hospitals Annual Sports Meet-1.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "Central Revenue Services Annual National Sports Meet",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/CRSCB Sports Meet-1.jpg"),
      require("../assets/events/CRSCB Sports Meet-2.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/CRSCB Sports Meet-1.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "Special Olympics Training Camp",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/Special Olympics Training Camp-1.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Special Olympics Training Camp-1.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "National Squash Tournament",
    "Para1": "The first edition of ‘IIT Gandhinagar Squash Open’, jointly organised by the Indian Institute of Technology Gandhinagar (IITGN), Squash Rackets Federation of India (SRFI), and All Gujarat Squash Racquet Association, concluded at IITGN’s ultramodern Sports Complex on August 21, 2022.",
    "Para2": " As many as 243 squash players from all over the country participated in the five-day national-level tournament, which commenced on August 17, 2022. The tournament was played by athletes in 13 different categories, including Men; Women; Men Over (MO) 35 and 45; Girls Under (GU) 11, 13, 15, and 19; and Boys Under (BU) 11, 13, 15, 17, and 19. Navaneeth Prabhu S, a seed 1 player, emerged as the winner in Men’s category by defeating Adarsh Banodha by 11-6, 12-10, and 11-6 in the final playoff. The Women’s category trophy was lifted by Sanika Choudhari, who defeated seed 3/4 player Neaketa Chawla by 11-4, 11-1, and 11-0 in the final match. The Men Over (MO) 35 and 45 category trophies were bagged by Ashish Keskar and Saurab Nayar, respectively. Anika Kalanki, Diva Shah, Sehar Nayar, and Shameena Riaz (all players with a seed score) won in Girls Under (GU) 11, 13, 15, and 19 categories, respectively. Fareed Andrabi, Lokesh Subramani, Dev Sharma, Tavneet Singh Mundra, and Sharan Punjabi (all players with a seed score) won in Boys Under (BU) 11, 13, 15, 17, and 19 categories, respectively.",
    "Images": [
      require("../assets/events/National Squash Tournament-1.jpg"),
      require("../assets/events/National Squash Tournament-2.jpg"),
      
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/National Squash Tournament-1.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "ARA FC State Football Tournament",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/Football.jpg"),
      require("../assets/events/ARA FC State Football Tournament-1.jpg"),
    ],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Football.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "Maruti Suzuki Sports Meet",
    "Para1": "",
    "Para2": "",
    "Images": [],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Maruti Suzuki Sports Meet.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "Medicos Premier League",
    "Para1": "",
    "Para2": "",
    "Images": [],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Cricket.jpg"),
    "ExternalLink":""
  },
  {
    "EventName": "Tata Consulting Engineers Limited Sports Meet",
    "Para1": "",
    "Para2": "",
    "Images": [],
    "PageClassification":"Events Hosted",
    "CardImage": require("../assets/events/Tata Consulting Engineers Limited Sports Meet.jpg"),
    "ExternalLink":""
  },

  // {
  //   "EventName": "Rannkaushal",
  //   "Para1": "",
  //   "Para2": "",
  //   "Images": [require("../assets/events/Rannkaushal-1.jpg"),
  // ],
  //   "CardImage": require("../assets/events/Rannkaushal-1.jpg")
  // },
  // "PageClassification":"Events Hosted",
  // {
  //   "EventName": "Inter IIT Meet",
  //   "Para1": "Inter-IIT sports meet is an annual extravaganza which brings top athletes from the country’s best technical institutions at one place. It showcases the skill, talent and vigour of young India. Values of competitiveness and sports spirit fly high in the event. Over the past 54 occasions, this event has given us some truly glorious moments.",
  //   "Para2": "It’s a matter of great pride and a beautiful coincidence that IIT Roorkee is co-hosting the 55th Inter-IIT Sports meet with IIT Delhi in a year when the institute is celebrating it’s 175 years of existence. The state-of-the-art sporting facilities are geared up to welcome the guests. Every information related to the event has been very well furnished in this website. Stay connected with it to get all the latest information of the event!",
  //   "Images": [
  //     require("../assets/events/Inter IIT Meet-1.jpg"),
  //     require("../assets/events/Inter IIT Meet-2.jpg"),
  //     require("../assets/events/Inter IIT Meet-3.jpg"),
  // ],
  //   "CardImage": require("../assets/events/Inter IIT Meet-1.jpg"),
  // "PageClassification":"Events Hosted",
  //   "ExternalLink":"https://www.instagram.com/interiit2022/"
  // },
  {
    "EventName": "Athe-League",
    "Para1": "The league is a quest of 6 teams to battle it out for the title of champions. It provides a platform for every person in the IITGN community to show their Hard work and talents on track and field. The teams will be decided by selecting captains, followed by the auction of all registered players.",
    "Para2": "The six teams are: Deadly Hawks, Thunderbolts, Alpha Athletes, Second Wind, Black Sword, Blue Butchers",
    "Images": [
      require("../assets/events/leagues/Athe-league-1.jpg"),
      require("../assets/events/leagues/Athe-league-2.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Athe-league-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":"https://www.instagram.com/athe_league_iitgn/"
  },
  {
    "EventName": "Badminton Super League (BSL)",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/leagues/Badminton League-1.jpg"),
      require("../assets/events/leagues/Badminton League-2.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Badminton League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":"https://www.instagram.com/badmintonsuperleague/"
  },
  {
    "EventName": "IITGN Basketball League (IBL)",
    "Para1": "What started in 2015 as a simple tournament meant only for regular players back in 2015, has quickly turned into a much loved and anticipated annual event of basketball. We have had overwhelming responses from the last two editions of the League. Boys and girls compete in their respective categories. This has been possible only because of the great enthusiasm shown by the entire community. IBL provides a platform for aspiring players to show off their skills and earn a chance to be part of the college team. It pushes current players to realize their full potential so they can perform better in bigger tournaments like the annual Inter-IIT Sports Meet. The League is also refreshing for the players since they get a chance to express themselves on the court, away from the pressures of academic life.",
    "Para2": "At the end of the day, the League is simply a great time for its participants, whether on the court, playing, or off the court, watching.",
    "Images": [
      require("../assets/events/leagues/Basketball League-1.jpg"),
      require("../assets/events/leagues/Basketball League-2.jpg"),
      require("../assets/events/leagues/Basketball League-3.jpg"),
      require("../assets/events/leagues/Basketball League-4.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Basketball League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":""
  },
  {
    "EventName": "League of Football Players (LFP)",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/leagues/Football League-1.jpg"),
      require("../assets/events/leagues/Football League-2.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Football League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":"https://www.instagram.com/football_iitgn/"
  },

  {
    "EventName": "Intra IITGN Table tennis League (IITL)",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/leagues/Table Tennis League-1.jpg"),
      require("../assets/events/leagues/Table Tennis League-2.jpg"),
      require("../assets/events/leagues/Table Tennis League-3.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Table Tennis League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":""
  },

  {
    "EventName": "Cricket Combat League (CCL)",
    "Para1": "Intra-College Cricket League of IIT Gandhinagar",
    "Para2": "",
    "Images": [
      require("../assets/events/leagues/Cricket League-1.jpg"),
      require("../assets/events/leagues/Cricket League-2.jpg"),
      require("../assets/events/leagues/Cricket League-3.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Cricket League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":"https://www.instagram.com/cricket_iitgn/"
  },
  {
    "EventName": "Srija Memorial League (SML)",
    "Para1": "",
    "Para2": "",
    "Images": [
      require("../assets/events/leagues/Volleyball League-1.jpg"),
      require("../assets/events/leagues/Volleyball League-2.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Volleyball League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":"https://www.instagram.com/volleyball_iitgn/"
  },
  {
    "EventName": "Kautilya Chess League (KCL)",
    "Para1": "Chess is a great way to challenge our mind and improve our cognitive abilities. The Kautilya Chess League is an excellent opportunity for enthusiasts to test their skills against their peers and to enjoy some friendly competition. Kautilya Chess League is for all members of the IIT Gandhinagar community, including students, faculty, and staff.",
    "Para2": "",
    "Images": [
      require("../assets/events/leagues/Kautilya Chess League-1.jpg"),
  ],
    "CardImage": require("../assets/events/leagues/Kautilya Chess League-1.jpg"),
    "PageClassification":"League",
    "ExternalLink":""
  }, 
  // {
  //   "EventName": "Hallabol",
  //   "Para1": "Hallabol is an all-night intra-institute sports Festival at IITGN, drawing participation from students, staff and faculty. The games played with modified rules are Futsal, Tug of War, Frisbee, Touch Rugby, Foot Volley, Gully Cricket, 7 Stones, 3 a side Baddy, Basky, Dodge ball and Kho-Kho.",
  //   "Para2": "",
  //   "Images": [
  //     require("../assets/events/Hallabol-1.jpg"),
  //     require("../assets/events/Hallabol-2.jpg"),
  //     require("../assets/events/Hallabol-3.jpg"),
  //     require("../assets/events/Hallabol-4.jpg"),
  //     require("../assets/events/Hallabol-5.jpg"),
  //     require("../assets/events/Hallabol-6.jpg"),
  //     require("../assets/events/Hallabol-7.jpg"),
  //     require("../assets/events/Hallabol-8.jpg"),
  //     require("../assets/events/Hallabol-9.jpg"),
  //     require("../assets/events/Hallabol-10.jpg"),
    
  // ],
  //   "CardImage": require("../assets/events/Hallabol-1.jpg"),
  //   "PageClassification":"League",
  //   "ExternalLink":"https://students.iitgn.ac.in/hallabol-23/"
  // },
]